export enum ROUTES {
  PHONE_VERIFICATION = 'phone-verification',
  API_KEY = 'api-key',
  HISTORY = 'history',
}
